import { Injectable, signal } from '@angular/core';
import { toNumber } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';

import { ExtendableDropdownOption } from '@shared/components/extendable-options-dropdown/extendable-options-dropdown.component';
import { listInvoiceCostCategoryLineItemsQuery } from '@shared/services/gql.service';

export interface MapActivitiesLineItemOption extends ExtendableDropdownOption {
  initialItemValue?: number;
  isExistingItem?: boolean;
}

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class MapActivitiesModalService {
  invoiceItemOptions = signal<MapActivitiesLineItemOption[]>([]);

  private lineItemIntegrationOptions: MapActivitiesLineItemOption[] = [];
  private lineItemPDFOptions: MapActivitiesLineItemOption[] = [];

  addInvoiceItemOptions(option: ExtendableDropdownOption): void {
    this.invoiceItemOptions.update((options: ExtendableDropdownOption[]) => {
      options.push(option);

      return options;
    });
  }

  getLineItemIntegrationOptions(): MapActivitiesLineItemOption[] {
    return this.lineItemIntegrationOptions;
  }

  getLineItemPDFOptions(): MapActivitiesLineItemOption[] {
    return this.lineItemPDFOptions;
  }

  initInvoiceItemOptions(): void {
    const options: MapActivitiesLineItemOption[] = [];

    options.push(...this.lineItemPDFOptions, ...this.lineItemIntegrationOptions);

    this.invoiceItemOptions.set(options);
  }

  setLineItemIntegrationOptions(data: listInvoiceCostCategoryLineItemsQuery[]): void {
    this.lineItemIntegrationOptions =
      data.map((item) => {
        return {
          id: uuidv4(),
          initialItemValue:
            (Object.hasOwn(item, 'amount') && item.amount) ||
            (Object.hasOwn(item, 'Amount') && item.amount) ||
            0,
          isExistingItem: true,
          value: item.description || '',
        } as MapActivitiesLineItemOption;
      }) || [];
  }

  setLineItemPDFOptions(
    gridData: Record<
      string,
      {
        value: number | string;
      }
    >[],
    firstPriceField: string
  ): void {
    this.lineItemPDFOptions =
      gridData.map((row) => {
        return {
          id: uuidv4(),
          initialItemValue: toNumber(row[firstPriceField]?.value || 0),
          isExistingItem: true,
          value: row.col_1.value,
        } as MapActivitiesLineItemOption;
      }) || [];
  }
}
